export const isType1 = (input: number) => Math.floor(input) % 10 === 1 && Math.floor(input) % 100 !== 11;
